import { Component, OnDestroy, OnInit } from '@angular/core';
import { fadeIn } from '../../../../animations/form-error';
import { BasePageComponent } from '../../../base-page';
import { IOption } from '../../../../ui/interfaces/option';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { CountryColumnName, ICountryColumnName } from '../../countries/country-column-name';
import { MatDialogRef } from '@angular/material/dialog';
import { MoniesService } from '../monies.service';
import { FormService } from '../../../../shared/services/form.service';
import { TCModalService } from '../../../../ui/services/modal/modal.service';
import { CountryService } from '../../countries/countries.service';
import { Store } from '@ngrx/store';
import { IAppState } from '../../../../interfaces/app-state';
import { HttpService } from '../../../../services/http/http.service';
import { Country, ICountry } from '../../../../model/country.model';
import { IMoneyColumnName, MoneyColumnName } from '../money-column-name';
import { IMoney, Money } from '../../../../model/money.model';
import { takeUntil } from 'rxjs/operators';
import { AccountService } from '../../../../services/ServiceEntity/account.service';
import { Subject } from 'rxjs';
import { SUFFIX_ICON_FORM, WIDTH_MEDIUM_POPUP_CLASS } from '../../../../shared/constant/css-style/css-class.constant';

/**
 * Permet de gérer l'ajout des monies.
 */
@Component({
  selector: 'app-monies-add',
  templateUrl: './monies-add.component.html',
  animations: [fadeIn]
})
export class MoniesAddComponent extends BasePageComponent
  implements OnInit, OnDestroy {
  isSaving = false;
  successSave = false;
  serverHasError = false;

  theDialogRef: MatDialogRef<MoniesAddComponent>;

  private subs$ = new Subject<void>();
  monies: IOption[] = [];
  editForm: UntypedFormGroup;
  column: IMoneyColumnName;

  constructor(
    private accountService: AccountService,
    private formService: FormService,
    private dialogRef: MatDialogRef<MoniesAddComponent>,
    private moniesService: MoniesService,
    private columnName: MoneyColumnName,
    private fb: UntypedFormBuilder,
    private modal: TCModalService,
    store: Store<IAppState>, httpSv: HttpService) {
    super(store, httpSv);
    console.log('## construct money add');
    this.theDialogRef = this.dialogRef;
    const column = this.columnName.getColumnName();
    this.column = column;
    this.initForm(fb, column);
  }

  ngOnInit(): void {
    console.log('## init money add');
    this.accountService.identity().pipe(takeUntil(this.subs$))
      .subscribe(account => {
        super.setLoaded();
      })
  }

  ngOnDestroy() {
    console.log('## destroy money add');
    this.formService.free(this.subs$);
    this.successSave = false;
  }

  getWidthPopupClass() {
    return WIDTH_MEDIUM_POPUP_CLASS;
  }

  getSuffixIconForm(): string {
    return SUFFIX_ICON_FORM;
  }

  initForm(fb: UntypedFormBuilder, column: IMoneyColumnName) {
    if (fb && column) {
      this.editForm = this.fb.group({
        [column.id]: [],
        [column.label]: [
          '',
          [Validators.required, Validators.minLength(2),
            Validators.maxLength(50), Validators.pattern('^[A-Za-z]+((\\s)?([A-Za-z])+)*$')]
        ],
        [column.value]: [],
        [column.unit]: [],
        [column.labelCourt]: [
          '',
          [Validators.required, Validators.minLength(2),
            Validators.maxLength(10), Validators.pattern('^[A-Za-z]+((\\s)?([A-Za-z])+)*$')]
        ],
        [column.codeMoney]: [
          '',
          [Validators.required, Validators.minLength(2),
            Validators.maxLength(5), Validators.pattern('^[A-Za-z]+((\\s)?([A-Za-z])+)*$')]
        ]
      });
    }
  }

  /**
   * Enregistre un type de account ressource.
   */
  save() {
    console.log('## save money');
    this.isSaving = true;
    this.successSave = false;
    this.serverHasError = false;
    const c: ICountry = this.createFromForm();
    console.log('## c: ' + JSON.stringify(c));
    this.moniesService.create(c).subscribe(res => {
        console.log('## success create money');
        this.serverHasError = false;
        this.responseFromServer();
        this.editForm.reset();
        this.successSave = true;
        this.moniesService.getAllMoney();
      },
      err => {
        console.log('## error create money');
        this.responseFromServer();
        this.serverHasError = true;
        this.successSave = false;
      });
  }

  responseFromServer() {
    setTimeout(() => {
      this.isSaving = false;
    }, 300);
  }

  private createFromForm(): IMoney {
    return {
      ...new Money(),
      id: this.editForm.get(['id']).value,
      label: this.editForm.get(['label']).value,
      value: this.editForm.get(['value']).value,
      unit: this.editForm.get(['unit']).value,
      labelCourt: this.editForm.get(['labelCourt']).value,
      codeMoney: this.editForm.get(['codeMoney']).value
    };
  }
  reset(){
    this.editForm.reset();

  }

  closeModal() {
    console.log('## close country add');
    this.dialogRef.close();
    this.successSave = false;
    this.serverHasError = false;
    this.editForm.reset();
  }

  isInvalid(): boolean {
    return this.formService.isInvalidForm(this.editForm);
  }

  isRequired(column: string): boolean {
    return this.formService.isRequired(this.editForm, column);
  }

  isInvalidDirtyOrtouched(column: string): boolean {
    return this.formService.isInvalidDirtyOrTouched(this.editForm,
      column);
  }

  getMinLength(column: string): number {
    return this.formService.getMinLength(this.editForm, column);
  }

  getMaxLength(column: string): number {
    return this.formService.getMaxLength(this.editForm, column);
  }

  hasErrorEmail(column: string): boolean {
    return this.formService.hasErrorEmail(this.editForm, column);
  }

  hasErrorPattern(column: string): boolean {
    return this.formService.hasErrorPattern(this.editForm, column);
  }

  hasErrorMinLength(column: string): boolean {
    return this.formService.hasErrorMinLength(this.editForm, column);
  }

  hasErrorMaxLength(column: string): boolean {
    return this.formService.hasErrorMaxLength(this.editForm, column);
  }

}
